/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { and, isArchivedFilter } from '../data'

interface InquiryHistory { //adjust the interface to accept any type of data
  'Action/Action'?: any
  ActionCode: string
  AssignedTo?: any //Person_Single
  InquiryGUID: string
  InquiryID: string
  IsArchived: boolean
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
  'PreviousSection/MetadataValue'?: any
  PreviousSectionCode?: number
  PreviousServicingBy?: string
  'PreviousStatus/StatusDescription'?: any
  PreviousStatusCode?: string
  ResponseReceived?: boolean
  'Section/MetadataValue'?: any
  SectionCode: number
  ServicingBy: string
  'Status/StatusDescription'?: any
  StatusCode: string
  UserRole: string
  eKey?: string
  eTag?: string
}
interface InquiryHistoryArgs {
  inquiryGuid?: string
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  ActionCode: 'ActionCode',
  AssignedTo: 'AssignedTo',
  InquiryGUID: 'InquiryGUID',
  InquiryID: 'InquiryID',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  PreviousSectionCode: 'PreviousSectionCode',
  PreviousServicingBy: 'PreviousServicingBy',
  PreviousStatusCode: 'PreviousStatusCode',
  ResponseReceived: 'ResponseReceived',
  SectionCode: 'SectionCode',
  ServicingBy: 'ServicingBy',
  StatusCode: 'StatusCode',
  UserRole: 'UserRole',
  eKey: 'eKey',
  eTag: 'eTag'
}

const LIST_NAME = 'InquiryHistoryList'

const getInquiryHistory = async (
  args: InquiryHistoryArgs
): Promise<InquiryHistory[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructInquiryFilter(args)

  const items = await list
    .query()
    .filter(filter)
    .select(...Object.values(COLUMN_NAMES))
    .expand()
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemCreated }])
    .get()

  return [...items] as InquiryHistory[]
}
const constructInquiryFilter = (args: InquiryHistoryArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchivedFilter ?? null))
  if (args.inquiryGuid) {
    filters.push(`InquiryGUID eq '${args.inquiryGuid}'`)
  }
  const filter = and(...filters)
  return filter
}
//add HistoryList interface where any
const addOrUpdateInquiryHistory = async (item : InquiryHistory) => {
  try {
    const list = await mpfRListsHttp().getList(LIST_NAME)
    const result = await list.addOrUpdateItem(item)
    
    return result
  } catch (error) {
    console.error('An error occurred while adding or updating the dueout in the history list:', error)
    throw new Error('Failed to add or update dueout in the history')
  }
}

export {
  COLUMN_NAMES,
  type InquiryHistory,
  type InquiryHistoryArgs,
  LIST_NAME,
  addOrUpdateInquiryHistory,
  getInquiryHistory,
}
